<template>
    <v-select
        :value="value"
        :label="label"
        :multiple="multiple"
        :items="items"
        :item-text="itemText"
        :item-value="itemValue"
        :return-object="returnObject"
        :class="[noTopMargin ? 'mt-0' : 'mt-3', type=='filter' ? 'filter-select' : '',]"
        menu-props="offsetY"
        color="secondary"
        item-color="secondary"
        :outlined="type=='filter'? undefined : true"
        dense
        :chips="chips"
        :deletable-chips="deletableChips"
        :small-chips="smallChips"
        :open-on-clear="openOnClear"
        hide-details="auto"
        :loading="loading"
        :success="success"
        :error-messages="errorMessages"
        :rules="rules"
        :rounded="rounded"
        :clearable="!noClearIcon&&!readonly"
        :readonly="readonly"
        :disabled="disabled"
        :suffix="suffix"
        :solo="type=='filter'? true : undefined"
        :flat="type=='filter'? true : undefined"
        :prepend-icon="icons[`${prependIcon}`] || prependIcon"
        :prepend-inner-icon="icons[`${prependInnerIcon}`] || prependInnerIcon"
        :append-icon="icons[`${appendIcon}`] || appendIcon"
        :append-outer-icon="icons[`${appendOuterIcon}`]"
        @input="$emit('input', $event)"
        @change="$emit('change')"
        @click="$emit('click')"
        @click:append="$emit('click:append')"
        @click:clear="$emit('click:clear')"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
    >
        <template v-if="$scopedSlots['prepend-inner']" v-slot:prepend-inner>
            <slot name="prepend-inner"></slot>
        </template>
         <template v-if="$scopedSlots.selection" v-slot:selection="slotProps">
            <slot name="selection" v-bind="slotProps"></slot>
        </template>
        <template v-if="$scopedSlots.item" v-slot:item="slotProps">
            <slot name="item" v-bind="slotProps"></slot>
        </template>
    </v-select>
</template>

<script>
import { mdiPlus, mdiPercent } from "@mdi/js";

export default {
    name: "BSelect",

    props: {
        value: {
            type: [String, Number, Object, Array]
        },
        label: String,
        multiple: Boolean,
        items: Array,
        readonly: Boolean,
        itemText: String,
        itemValue: String,
        returnObject: Boolean,
        prependIcon: String,
        prependInnerIcon: String,
        appendIcon: String,
        appendOuterIcon: String,
        noTopMargin: Boolean,
        noClearIcon: Boolean,
        rounded: Boolean,
        disabled: Boolean,
        success: Boolean,
        errorMessages: String,
        rules: Array,
        loading: Boolean,
        chips: Boolean,
        deletableChips: Boolean,
        smallChips: Boolean,
        openOnClear: Boolean,
        type: String,
        suffix: String,
    },

    data: () => ({
        icons: {
            mdiPlus,
            mdiPercent
        }
    })
};
</script>
<style>

.filter-select {  
    width: auto;
    float: left;
    background: transparent !important;
}

.filter-select *{
    background: transparent;
}

.filter-select .v-input__control {
    flex-grow: 0;
    width: auto;
}

.filter-select:hover .v-input__slot{
    background-color: rgba(55,55,55,0.1)  !important;
}

.v-input--is-focused .v-input__slot{
    background-color: rgba(55,55,55,0.1)  !important;
}

.filter-select .v-text-field__suffix{
    cursor: pointer !important;
}

.filter-select .v-select__selections {
    max-width: 0px;
    height: 0px
}

.filter-select .v-input__icon--clear {
    display: none;
}

.filter-select .v-input__append-inner{
    margin-left: 0px !important;
}

</style>